import styles from "./index.module.scss";
import React, { useEffect } from "react";
import { Speaker } from '../utils/Icons'
import TutorialSlide from "./TutorialSlide";
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { loginRedirect, registerRedirect } from '../../utils/Shared/methods';

function CustomDataTutorialPage() {
    const [isMemberLogin, setIsMemberLogin] = useState(false);
    const checkMemberLogin = () => {
    if (window.localStorage.getItem('user-token')) {
        setIsMemberLogin(true);
    }
};
    useEffect(() => {
        window.scrollTo(0, 0);
        checkMemberLogin();
    }, []);

    return (
        <div className={styles.customDataTutorialPage}>
            <div className={styles.breadcrumbsBlock}>
                <div className={styles.breadcrumbs}>
                    {/* <Link to="/statistics/ChishangEarthquake">
                        <span>
                            0918 池上地震-花東地區地震認知與避難行為調查 (2023)
                        </span>
                    </Link>
                    <span className={styles.breadcrumbsSeparator}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <line
                                x1="11.6036"
                                y1="0.728553"
                                x2="0.996952"
                                y2="11.3352"
                                stroke="#5B5B5B"
                            />
                        </svg>
                    </span>
                    <span>
                        <b>客製化專區</b>
                    </span> */}
                </div>
                <div className={styles.chartDataCTA}>
                    <Link
                        to="/statistics/ChishangEarthquake/chart-data"
                        className={styles.chartDataLink}
                    >
                        前往主題圖表
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M10 8L14 12L10 16"
                                stroke="#A479E9"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                </div>
            </div>
            <div className={styles.heroSection}>
                <div className={styles.heroSectionText}>
                    <h1>客製化專區</h1>
                    <p>Customization</p>
                </div>
            </div>
            <div className={styles.signUpSection}>
                <div className={styles.signUpSectionHeader}>
                    <Speaker />
                    <span>加入會員就能試試客製化專區</span>
                </div>
                <div className={styles.signUpSectionContent}>
                    <b>
                        池上地震完整的調查數據，僅需三個簡單的操作步驟，即可產出精美的客製化圖表，最後還能一鍵打包下載數據及圖表。
                    </b>
                </div>
            </div>
            <TutorialSlide isMemberLogin={isMemberLogin} />
            {/* <div className={styles.signUpCTASection}>
                <h4>立即加入會員，即可享有此功能！</h4>
                <div>
                    <button>登入</button>
                    <button>註冊會員</button>
                </div>
            </div> */}          
            {isMemberLogin === false && (
                <div className={styles.signUpCTASection}>
                    <h4>立即加入會員，即可享有此功能！</h4>
                    <div>
                        <button onClick={() => loginRedirect()}>登入</button>
                        <button onClick={() => registerRedirect()}>註冊會員</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CustomDataTutorialPage;